import { useState } from "react"

import Layout from "./components/Layout"
import Loading from "./components/pages/Loading"
import Preview from "./components/pages/VideoShare/Preview"
import VideoShare from "./components/pages/VideoShare/VideoShare"
import Empty from "./components/pages/Empty/Empty"
import Processing from "./components/pages/Processing/Processing"

import { shareVideo } from "./helpers/shareVideo"
import { useVideoDownload } from "./hooks/useVideoDownload"

// import TestMenu from "./components/TestMenu"

export function App() {
  const [isPreviewReady, setPreviewReady] = useState(false)
  const {
    cachedVideoBlob,
    cachedVideoUrl,
    isCaching,
    isLoading,
    page,
    urlHash,
    videoPreviewUrl,
  } = useVideoDownload()

  const handleShareVideo = async () => {
    return shareVideo(urlHash, cachedVideoBlob)
  }

  if (isLoading) return <Loading />
  const isDownloadDisabled = page !== "default" || !isPreviewReady || isCaching

  return (
    <>
      {/* <TestMenu setPage={setPage} page={page} /> */}
      <Layout>
        {!(page === "empty") && page === "default" && (
          <Preview
            page={page}
            videoUrl={videoPreviewUrl || cachedVideoUrl}
            onPreviewReadyChange={setPreviewReady}
          />
        )}
        {page === "default" && (
          <VideoShare
            shareVideo={handleShareVideo}
            isCaching={isCaching}
            isDownloadDisabled={isDownloadDisabled}
          />
        )}

        {page === "processing" && <Processing />}
        {page === "empty" && <Empty />}
      </Layout>
    </>
  )
}
